import React from "react";
import { FormattedMessage } from "react-intl";
import WizardConflictPopupCartItem from "../wizardConflictPopupCartItem";

const ReviewConflicts = ({ cartItems }) => {

  return (
    <>
      <p className="ui-popup__body-subtitle">
        <FormattedMessage id="confirmPopup.updateWizardIncompatibleItemsText" />
      </p>

      <ul className="apply-popup-list">
        {cartItems.map((cartItem) => (
          <WizardConflictPopupCartItem key={cartItem.id} cartItem={cartItem} />
        ))}
      </ul>
    </>
  );
};

export default ReviewConflicts;
